import { format, parseISO } from "date-fns";
import { DEFAULT_LOCALE, applyFormatters, formatDefault, getDate as getRegistryDate, toText } from "./Formatters";

export type AttributeValue = string | number | boolean | FileAttributeValue | Record<string, AttributeValue>[];

export const formatDate = (argument: string | Date | number, dateFormat: string, options?: any): string => {
  return format(typeof argument === "string" ? parseISO(argument) : argument, dateFormat, options);
};
export type FileAttributeValue = {
  /**
   * `id` is a ref identifier in file storage\
   * value after "base64" is a file name
   *
   * @example
   *  [
   *    "data:id=53eefeab-b0a4-40de-83d5-7eb063c909d2;base64,qweasdzxc",
   *    "data:id=6bbf79d2-6e84-49cc-9473-3bc3c3dfbcc1;base64,iuytrew"
   *  ]
   */
  fileRefs: string[];
};

/** @deprecated Use `FormatterName` from ./Formatters, which covers every registered formatter. */
export type Formatter = "currency" | `date ${string}` | "date";

/** @deprecated Moved to ./Formatters. */
export const getDate = getRegistryDate;

export interface FormatOptions {
  formatters?: string[];
  type?: string;
  locale?: string;
  /** "Now" for relative dates. Defaults to the current time. */
  now?: Date;
  /** Looks up another value by key, for `min` / `max` / `atShiftEnd` arguments. */
  resolve?: (key: string) => unknown;
}

/**
 * Renders a value for a template, as `processVar` does: applies the formatter
 * chain from the registry in ./Formatters (the single source of truth), or with
 * no formatters, renders dates in the locale's short form.
 */
export const formatValue = (value: AttributeValue, options?: FormatOptions): string | undefined => {
  if (value === null || value === undefined) {
    return undefined;
  }

  const { formatters, type, locale, now, resolve } = options || {};
  const resolvedLocale = locale || DEFAULT_LOCALE;

  if (!formatters?.length) {
    return formatDefault(toText(value), type, resolvedLocale);
  }
  return toText(applyFormatters(value, formatters, { type, locale: resolvedLocale, now, resolve }));
};
